import { makeStyles } from '@mui/styles';

const useApplicationStyle = makeStyles(() => ({
  root: {
    width: '100%',
    height: 'max(50vh, 60%)',
    background: 'none',
    marginBottom: 50,
    display: 'flex',
    alignItems: 'center',
  },
  applicationContainer: {
    transition: 'transform .2s ease-out',
    '&:hover': {
      transform: 'translate(0%, -5%)',
    },
    borderRadius: 30,
    border: '1px solid',
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, #EFDDCE 40%)',
    display: 'flex !important',
    flexDirection: 'column',
    alignItems: 'center',
    height: '80%',
    width: '80%',
    margin: 'auto',
    rowGap: 10,
    paddingTop: 20,
    boxShadow: '0 4px 8px 0 rgba(54, 56, 56, 0.815) !important',
  },
  applicationContainerDark: {
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 60%, rgba(56, 52, 55, 1) 40%)',
    boxShadow: '0 4px 8px 0 rgba(240, 238, 238, 0.815) !important',
  },
  applicationContainerMobile: {
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 45%, #EFDDCE 55%)',
  },
  applicationContainerMobileDark: {
    background: 'linear-gradient(to bottom, rgba(0, 0, 0, 0) 45%, rgba(56, 52, 55, 1) 55%)',
  },
  appTitle: {
    fontSize: 'max(2vw, 20px) !important',
    fontWeight: 'bold !important',
    fontFamily: 'Lato !important',
  },
  demoContainer: {
    display: 'flex',
    columnGap: 10,
    justifyContent: 'center',
    alignItems: 'center',
    width: '90%',
    height: '20vh',
    padding: 10,
  },
  demo: {
    height: 'max(20vh, 100px)',
    width: 'max(25vw, 200px)',
  },
  descriptionContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    width: '100%',
    bottom: 0,
    rowGap: 5,
    textAlign: 'center',
    marginTop: 15,
  },
  descriptionContainerMobile: {
    width: '90%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  repo: {
    '&:hover': {
      color: '#8CB4FF',
    },
  },
}));

export default useApplicationStyle;
